import { numberToPrettyString } from '@cian/utils';
import { PRICE_TYPE } from '../PriceType/constants';
import { PriceContainerProps } from './types';

export const getPriceCaption = (
  price: number,
  area: number,
  priceTypeWithPaymentPeriod: ReturnType<typeof getFormattedPriceType>,
) => {
  if (!price || !area) {
    return undefined;
  }

  switch (priceTypeWithPaymentPeriod) {
    case PRICE_TYPE.squareMeterMonthly:
      return `${numberToPrettyString(Math.round(price * area))} ₽ в мес.`;

    case PRICE_TYPE.squareMeterAnnual:
      return `${numberToPrettyString(Math.round((price * area) / 12))} ₽ в мес.`;

    case PRICE_TYPE.allMonthly:
      return `${numberToPrettyString(Math.round(price / area))} ₽ за м²`;

    case PRICE_TYPE.squareMeter:
      return `${numberToPrettyString(Math.round(price * area))} ₽ за всё`;

    case PRICE_TYPE.all:
      return `${numberToPrettyString(Math.round(price / area))} ₽ за м²`;

    default:
      return undefined;
  }
};

export function getFormattedPriceType(
  priceType: PriceContainerProps['priceType'],
  paymentPeriod: PriceContainerProps['paymentPeriod'],
  isSale: PriceContainerProps['isSale'],
) {
  if (isSale) {
    return priceType === 'squareMeter' ? PRICE_TYPE.squareMeter : PRICE_TYPE.all;
  }

  if (priceType === 'squareMeter' && paymentPeriod === 'monthly') {
    return PRICE_TYPE.squareMeterMonthly;
  }

  if (priceType === 'squareMeter' && paymentPeriod === 'annual') {
    return PRICE_TYPE.squareMeterAnnual;
  }

  if (priceType === 'all' && paymentPeriod === 'monthly') {
    return PRICE_TYPE.allMonthly;
  }

  return undefined;
}
